import styled from "styled-components";

const StyledDiv = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border-radius: 0.3rem;
  background-color: #fff;
  padding: 1rem;
  margin: 0 1rem 0.3rem 1rem;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.6);
  max-width: ${({ maxWidth }) => maxWidth || "none"};
`;

const ResponsivContent = ({ children, maxWidth }) => {
  return <StyledDiv maxWidth={maxWidth}>{children}</StyledDiv>;
};

export default ResponsivContent;
